import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useMemo,
  useState
} from 'react'
import { setUserProperties } from '../amplitude'
import { UserProperty } from '../amplitude/amplitude.interface'
import getCampaignsAndVariants, {
  CampaignsAndVariants
} from './getCampaignsAndVariants'

declare global {
  interface Window {
    sitespect: string | undefined
  }
}

interface SitespectContextType {
  state: CampaignsAndVariants
  setCampaignsAndVariants: Dispatch<SetStateAction<CampaignsAndVariants>>
}

function throwMissingContext() {
  throw new Error('SitespectContext is missing')
}

export const SitespectContext = createContext<SitespectContextType>({
  state: {
    variants: {},
    campaigns: {}
  },
  setCampaignsAndVariants: throwMissingContext
})

export const SitespectProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [state, setCampaignsAndVariants] = useState(() =>
    getCampaignsAndVariants()
  )

  const context = useMemo(
    () => ({
      state,
      setCampaignsAndVariants
    }),
    [state]
  )

  useEffect(() => {
    setUserProperties({
      [UserProperty.SitespectVariants]: Object.entries(state.variants)
        .filter(([, isInVariant]) => isInVariant)
        .reduce(
          (previous, [variantId]) => [...previous, variantId],
          [] as string[]
        )
    })
  }, [state])

  return (
    <SitespectContext.Provider value={context}>
      {children}
    </SitespectContext.Provider>
  )
}
